export default function formatarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    let cnpjFormatado;
    cnpjFormatado = cnpj.replace(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/,
        function (regex, argumento1, argumento2, argumento3, argumento4, argumento5) {
            return argumento1 + '.' + argumento2 + '.' + argumento3 + '/' + argumento4 + '-' + argumento5;
        });
    return cnpjFormatado;
}